import React, { useState } from "react";

import { useAuth, useAuthDispatch, AUTH_ACTIONS } from "@app/contexts/AuthContext";
import { apiCall } from '@app/utils/apiCall';

export default function SettingLoader({children}) {    
    const [loaded, setLoaded] = useState(false);

    const auth = useAuth();
    const authDispatch = useAuthDispatch();

    if (!loaded && auth.token) {
        apiCall({
            method: "get",
            path: "/api/v1/sessions/session_settings/",
            auth: auth,
            onSuccess: (response) => {
                authDispatch({
                    type: AUTH_ACTIONS.LOAD_SETTING,
                    payload: {
                        setting: response.data.setting                        
                    }
                });
                setLoaded(true);
            }
        });
    }
        
    return (
        <>
            {children}
        </>
    );    
}
